import React, { useState } from 'react';
import { Upload, Image as ImageIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
export function GangSheetBuilder() {
  const [isDragging, setIsDragging] = useState(false);
  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(true);
  };
  const handleDragLeave = () => {
    setIsDragging(false);
  };
  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(false);
    // Handle file drop logic here
  };
  return <section className="py-16 bg-atomic-charcoal border-y border-white/10" data-id="element-97">
      <div className="container mx-auto px-4 md:px-6" data-id="element-98">
        <div className="max-w-2xl mx-auto" data-id="element-99">
          <div className="text-center mb-8" data-id="element-100">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-3" data-id="element-101">
              DTF Gang Sheet Builder
            </h2>
            <p className="text-gray-400" data-id="element-102">
              Upload your designs to create a custom gang sheet
            </p>
          </div>

          <div className="flex flex-col items-center gap-6" data-id="element-103">
            {/* Primary Button */}
            <Button size="lg" className="min-w-[200px]" onClick={() => {
            // Trigger file input
            document.getElementById('file-input')?.click();
          }} data-id="element-104">
              <Upload className="mr-2 w-5 h-5" data-id="element-105" />
              Select Image
            </Button>
            <input id="file-input" type="file" accept="image/*" className="hidden" onChange={e => {
            // Handle file selection
          }} data-id="element-106" />

            {/* OR Divider */}
            <span className="text-gray-500 font-medium text-sm" data-id="element-107">OR</span>

            {/* Drop Zone */}
            <motion.div onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop} animate={{
            borderColor: isDragging ? 'rgb(163, 230, 53)' : 'rgba(255, 255, 255, 0.2)',
            backgroundColor: isDragging ? 'rgba(163, 230, 53, 0.05)' : 'transparent'
          }} className="w-full border-2 border-dashed rounded-xl p-12 md:p-16 transition-colors cursor-pointer hover:border-atomic-green/50 hover:bg-atomic-green/5" onClick={() => document.getElementById('file-input')?.click()} data-id="element-108">
              <div className="flex flex-col items-center justify-center gap-4 text-center" data-id="element-109">
                <div className="w-16 h-16 rounded-full bg-atomic-dark flex items-center justify-center text-atomic-green border border-white/10" data-id="element-110">
                  <Upload size={32} data-id="element-111" />
                </div>
                <p className="text-lg font-medium text-gray-300" data-id="element-112">
                  Drop Image Here
                </p>
              </div>
            </motion.div>

            {/* OR Divider */}
            <span className="text-gray-500 font-medium text-sm" data-id="element-113">OR</span>

            {/* Secondary Button */}
            <div className="flex flex-col items-center gap-2" data-id="element-114">
              <Button variant="outline" size="lg" className="min-w-[280px]" data-id="element-115">
                <ImageIcon className="mr-2 w-5 h-5" data-id="element-116" />
                Add Image from My Library
              </Button>
              <p className="text-xs text-gray-500 italic" data-id="element-117">
                You should log in to use this feature
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}